import React, { useState, useEffect, useRef } from 'react';
import { withRouter } from 'react-router';
import { useSnackbar } from 'notistack';
import { Paper, Grid, Accordion, AccordionSummary, AccordionDetails, Button, TextField, Switch, Tooltip, InputAdornment, IconButton } from '@material-ui/core';
import AddSection from './AddSection'
import SortSections from './SortSections'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import PublishIcon from '@material-ui/icons/Publish';
import { CkEditorText, DeletePopUp, EmptyCollection, PageLoader } from '../../../shared_elements';
import { checkApiStatus, onCheckFormPermission } from '../../../utils_v2';
import { globalGetService, globalPutService, globalDeleteService } from '../../../utils_v2/globalApiServices';
import SectionImportTemplate from './SectionImportTemplate';
import { helperFunc } from '../../projects/helperFunc';
import { Skeleton } from '@material-ui/lab';
import useWindowHeight from '../../../shared_elements/hooks/useWindowHeight';
import AddIcon from '@material-ui/icons/Add';
import AssetLopa from './AssetLopa';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
import moment from 'moment';
import { Check, Clear, Info } from '@material-ui/icons';
import { castleAirInstance, testLessor } from '../../../shared_elements/components';
import { globalPostService } from '../../../globalServices';
const signatureObj={name:'',date:'',company:'',signature:""}
const SectionCheckList = ({params, currentFormDetail,getCurrentFormDetail}) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const windowHeight = useWindowHeight();
    const [isLoading, setLoading] = useState(false);
    const [initialLoader, setInitialLoader] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(true);
    const [sectionCheckLists, setSectionCheckLists] = useState({list:[]});
    const [expanded, setExpanded] = useState(false);
    const [modal, setModal] = useState(false);
    const [error, setError] = useState({fields:{}, errorIndex:''});
    const [addSection, setAddSection] = useState({modal:false, data:null})
    const [deleteSection, setDeleteSection] = useState({modal:false, type:'', data:null})
    const [deleteSignature, setDeleteSignature] = useState({modal:false, type:'', data:null})
    useEffect(() => {
        getContentSections();
    }, []);
    const onFieldChange = (key, value, index, sectionId = null) => {
        if (sectionId) {
            setSectionCheckLists({
                ...sectionCheckLists,
                list: sectionCheckLists?.list?.map(section => section?.id !== sectionId ? section : {
                    ...section, sub_sections: section?.sub_sections.map((sbSec, sbSecIndex) => sbSecIndex !== index ? sbSec : {
                        ...sbSec, [key]: value ? value === "<p>1.&nbsp;</p>" ? "" : value : ''
                    })
                })
            })
        } else {
            setSectionCheckLists({
                ...sectionCheckLists,
                list: sectionCheckLists?.list?.map((section, sectionIndex) => sectionIndex !== index ? section : {
                    ...section, [key]: value ? value === "<p>1.&nbsp;</p>" ? "" : value : ''
                })
            })
        }
    }
   
    const onSignatureChange =(key, value, index)=>{
        setError({...error,fields:{
            ...error.fields,
            [key]:""
        }})
        setSectionCheckLists({
            ...sectionCheckLists,
            inspection_signatures:sectionCheckLists.inspection_signatures.map((sig, sigIndex)=> sigIndex !== index ? sig: {
                ...sig, [key]:value
            } )
        })
    }
 const getContentSections = (loaderType) => {
        if(loaderType === 'pageLoader'){
            setLoading(true)
        } else {
            setSkeletonLoader(true)
        }
       // loaderType === 'skeletonLoader' ? setSkeletonLoader(true):setLoading(true)     
        setInitialLoader(true)
        globalGetService(`technical/v2/workorder/${params.workOrderSlug}/inspection-sections/?asset_type=${params.type}`)
        .then(response => {
            setTimeout(() => {setInitialLoader(false)}, 400);
            if(checkApiStatus(response)){
                setSectionCheckLists(response.data.data)
                getCurrentFormDetail()
            }
            if(loaderType === 'pageLoader'){
                setLoading(false)
            } else {
                setSkeletonLoader(false)
            }
        })
    }
    const onDeleteSection = () => {
        setLoading(true)
        globalDeleteService(`technical/v2/workorder/${params.workOrderSlug}/inspection-sections/${deleteSection.data.id}/?asset_type=${params.type}`)
            .then(response => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    // if (deleteSection.type === 'Section') {
                        window.location.reload();
                    // } 
                    // else {
                    //     getCurrentFormDetail()
                    //     getContentSections();
                    // }
                    setLoading(false)
                    setDeleteSection({ modal: false, type: '', data: null });
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
            })
    }
    const updateSectionInfo = (data) => {
        globalPutService(`technical/v2/workorder/${params.workOrderSlug}/inspection-sections/${data.id}/?asset_type=${params.type}`, data)
            .then(response => {
                if (checkApiStatus(response)) {
                    // enqueueSnackbar(response.data.message, { variant: 'success',anchorOrigin:{horizontal:'right', vertical:'top'}});
                    getContentSections('pageLoader')
                    getCurrentFormDetail()
                } else {
                    enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                }
            });
    }
    const handleChange = (panel, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    const addSignatureRow =()=>{
        setError({fields:{}, errorIndex:''})
        setSectionCheckLists({
            ...sectionCheckLists,
            inspection_signatures:[signatureObj,...sectionCheckLists.inspection_signatures]
        })
    }
    const onBlurSignature = (data, index) => {
        let validateInput ={}
        validateInput ={
           name:  data?.name?.trim()? '':"Enter Name.",
           signature_date  :data?.signature_date ? moment(data?.signature_date).isValid()? moment(data?.signature_date).isAfter(moment(), 'day') ? 'Date cannot be future Date.' : '' :'Please enter Valid Date.':'Please enter Date.',
           company:  data?.company?.trim()? '':"Enter Company Name.",
        }
        if(Object.keys(validateInput).every(i=> validateInput[i] ==='')){
        let formData = new FormData();
        if (data.name !== undefined) formData.append('name', data.name);
        if (data.signature_date !== undefined) formData.append('signature_date', data.signature_date);
        if (data.company !== undefined) formData.append('company', data.company);
        if (data.signature !== undefined) formData.append('signature', data.signature);
        if (data.file !== undefined) formData.append('file', data.file);
        setLoading(true)
        const url = `technical/v2/workorder/${params.workOrderSlug}/inspection-signatures/?asset_type=${params.type}`;
        const apiCall = globalPostService(url, formData);
        apiCall.then(response => {
            setLoading(false)
            if (checkApiStatus(response)) {
                enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                getContentSections();
            } else {
                enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
            }
        });
        }else{
            setError({fields:validateInput, errorIndex:index})
        }
    }
    const deleteSignatureFn = () => {
         setError({fields:{}, errorIndex:''})
        if (deleteSignature?.data?.id) {
            setLoading(true)
            globalDeleteService(`technical/v2/workorder/${params.workOrderSlug}/inspection-signatures/${deleteSignature?.data?.id}/?asset_type=${params.type}`)
                .then(response => {
                    setLoading(false)
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                        setDeleteSignature({ modal: false, type: '', data: null })
                        setSectionCheckLists({
                            ...sectionCheckLists,
                            inspection_signatures: sectionCheckLists.inspection_signatures.filter((item, index) => item?.id !== deleteSignature?.data?.id)
                        })
                    } else {
                        enqueueSnackbar(response.data.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' } });
                    }
                })
        } else {
            setDeleteSignature({ modal: false, type: '', data: null })
            setSectionCheckLists({
                ...sectionCheckLists,
                inspection_signatures: sectionCheckLists.inspection_signatures.filter((item, index) => index !== deleteSignature?.data?.index)
            })
        }
    }
    return(
        <div className='t004-content-sections'>
            {skeletonLoader ?
                <div style={{marginTop:'15px'}}>
                    <div style={{display:'flex', gap:'8px', marginBottom:'8px'}}>
                        <Skeleton variant="rect" width={120} height={30} />
                        {castleAirInstance ? <Skeleton variant="rect" width={120} height={30} /> : null}
                    </div>
                    <Skeleton variant="rect" width={'100%'} height={(windowHeight - 250) + 'px'} />
                </div>:
                <>
                    <div className='content-sections-hd'>
                        <Grid container spacing={1}>
                            <Grid item md={6}>
                                <ul className='list-inline'>
                                    {onCheckFormPermission(currentFormDetail) ?
                                        <li className='list-inline-item'>
                                            <Button onClick={() => setAddSection({modal:true, data:{title:'', value:'',value_type:1,parent_section:null}})} color='primary' size='small' variant='contained'><AddIcon style={{ fontSize: '1.15rem', color:'#fff' }} />Add Section</Button>
                                        </li>:null
                                    }
                                     { <li className='list-inline-item'>
                                        <AssetLopa getCurrentFormDetail={getCurrentFormDetail} currentFormDetail={currentFormDetail}/>
                                    </li> }
                            </ul>
                        </Grid>
                        <Grid item md={6}>
                            <ul className='list-inline' style={{ float: 'right' }}>
                                {sectionCheckLists?.list?.length > 1 && onCheckFormPermission(currentFormDetail) ?
                                    <li className='list-inline-item'>
                                        <SortSections
                                            url={`technical/v2/workorder/${params.workOrderSlug}/inspection_sections_order/?asset_type=${params.type}`}
                                            toolTipContent='Sort Sections'
                                            assetSections={sectionCheckLists?.list?.map(section => ({ id: section.id, name: section.title, order: section.order }))}
                                            getResponseBack={()=>window.location.reload()}
                                        />
                                    </li> : null
                                }
                            </ul>
                        </Grid>
                    </Grid>
                </div>
                {sectionCheckLists?.list?.length ? <div>
                    {sectionCheckLists?.list?.map((section, sectionIndex) =>
                        <Accordion
                            expanded={expanded === `section_${sectionIndex}` && (!castleAirInstance || section?.value_type === 1) }
                            onChange={(event, isExpanded) => handleChange(`section_${sectionIndex}`, isExpanded) }
                        >
                            <AccordionSummary
                                expandIcon={ (!castleAirInstance || section?.value_type === 1) && <ExpandMoreIcon />}
                                id={`panel1bh-header_${sectionIndex}`}
                            >
                                <Grid container spacing={1} alignItems='center'>
                                    <Grid item md={10}>
                                        <div className='section-title-field' onClick={(e) => { e.preventDefault(); e.stopPropagation() }}>
                                            <TextField
                                                disabled={!onCheckFormPermission(currentFormDetail) || section?.is_system_generated}
                                                id={`section_name_${section?.id}`}
                                                placeholder='Type Section Name'
                                                fullWidth
                                                margin="none"
                                                InputLabelProps={{ shrink: true }}
                                                value={section?.title}
                                                onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange('title', e.target.value, sectionIndex) }}
                                                onBlur={(e) => updateSectionInfo({ ...section, title: e.target.value })}
                                                onFocus={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                                variant='outlined'
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item md={2}>
                                        {onCheckFormPermission(currentFormDetail)  ?
                                            <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                                  <li className='list-inline-item' onClick={(e) => { e.preventDefault(); e.stopPropagation() }}>
                                                    <Tooltip title={section?.value_type === null  ?'Enable Section Content' :"Disable Section Content"} arrow>
                                                        <Switch
                                                            checked={section?.value_type === null ? false : true}
                                                            onChange={(e) => { updateSectionInfo({ ...section, value_type: e.target.checked ? 1 : null }) }}
                                                            color="primary"
                                                            name="checkedB"
                                                            disabled={!onCheckFormPermission(currentFormDetail)}
                                                        />
                                                    </Tooltip>
                                                </li>
                                                <li className='list-inline-item'>
                                                    <Tooltip title='Delete Section' arrow>
                                                        <DeleteOutlineIcon onClick={(e) => {e.preventDefault();e.stopPropagation();setDeleteSection({modal:true, type:'Section', data:{id:section.id}})}} color='secondary' fontSize='medium' style={{cursor:'pointer'}} />
                                                    </Tooltip>
                                                </li>
                                            </ul> : null
                                        }
                                    </Grid>
                                </Grid>
                            </AccordionSummary>
                              <AccordionDetails>
                                <div className='section-content' onClick={(e) => { e.preventDefault(); e.stopPropagation() }}>
                                    <div className="editor-wrapper " >
                                        {section?.value_type === 1 &&!(castleAirInstance && section?.is_system_generated) &&
                                            <CkEditorText
                                                disabled={!onCheckFormPermission(currentFormDetail) || section?.is_system_generated}
                                                htmlData={castleAirInstance && section?.is_system_generated ? helperFunc.convertTextToEditorHtml(section.value) : section.value}
                                                onChangeData={(data) => onFieldChange('value',data, sectionIndex)}
                                                onBlurData={(data) => updateSectionInfo({ ...section, value: data })}
                                            />
                                        }
                                    </div>
                                    <Paper className='sub-sections-content'>
                                        {onCheckFormPermission(currentFormDetail)  ?
                                            <Grid container spacing={1}>
                                                <Grid item md={6}>
                                                    <ul className='list-inline'>
                                                        <li className='list-inline-item'>
                                                            <Button onClick={()=>setAddSection({modal:true, data:{title:'', value:'', value_type:1, parent_section:section.id}})} color='primary' size='small' variant='contained'><AddIcon style={{ fontSize: '1.15rem', color:'#fff' }} />Add Sub Section</Button>
                                                        </li>
                                                    </ul>
                                                </Grid>
                                                <Grid item md={6}>
                                                    <ul className='list-inline' style={{ float: 'right' }}>
                                                        {section?.sub_sections?.length && section?.sub_sections?.length > 1 ?
                                                            <SortSections
                                                                url={`technical/v2/workorder/${params.workOrderSlug}/inspection_sections_order/?asset_type=${params.type}`}
                                                                toolTipContent='Sort Sub-Sections'
                                                                assetSections={section?.sub_sections?.map(sbSection => ({ id: sbSection.id, name: sbSection.title, order: sbSection.order }))}
                                                                getResponseBack={()=>window.location.reload()}
                                                            /> : null
                                                        }
                                                    </ul>
                                                </Grid>
                                            </Grid> : null
                                        }
                                        {section?.sub_sections?.map((subSection, subSecIndex) =>
                                            <Paper key={`Section_${sectionIndex}_${subSecIndex}`} className='sub-section-blk'>
                                                <div className='sub-section-head'>
                                                    <Grid container spacing={1} alignItems='center'>
                                                        <Grid item md={11}>
                                                            <TextField
                                                                disabled={!onCheckFormPermission(currentFormDetail) || subSection?.is_system_generated === true}
                                                                id={`sb_section_name_${section?.id}_${subSection?.id}`}
                                                                fullWidth
                                                                margin="none"
                                                                InputLabelProps={{ shrink: true }}
                                                                value={subSection.title}
                                                                onChange={(e) => onFieldChange('title', e.target.value, subSecIndex, section?.id)}
                                                                onBlur={(e) => updateSectionInfo({ ...subSection, title: e.target.value })}
                                                                variant='outlined'
                                                            />
                                                        </Grid>
                                                        <Grid item md={1}>
                                                            {onCheckFormPermission(currentFormDetail)  ?
                                                                <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                                                    {castleAirInstance &&    <li className='list-inline-item' onClick={(e) => { e.preventDefault(); e.stopPropagation() }}>
                                                                        <Tooltip title={subSection?.value_type === null ? 'Enable Section Content' : "Disable Section Content"} arrow>
                                                                            <Switch
                                                                                checked={subSection?.value_type === null ? false : true}
                                                                                onChange={(e) => { updateSectionInfo({ ...subSection, value_type: e.target.checked ? 1 : null }) }}
                                                                                color="primary"
                                                                                name="checkedB"
                                                                                disabled={!onCheckFormPermission(currentFormDetail)}
                                                                            />
                                                                        </Tooltip>
                                                                    </li>}
                                                                    <li className='list-inline-item'>
                                                                        <Tooltip title='Delete Sub-Section' arrow>
                                                                            <DeleteOutlineIcon style={{ cursor: 'pointer' }} onClick={() => setDeleteSection({ modal: true, type: 'Sub Section', data: { id: subSection.id } })} color='secondary' fontSize='medium' />
                                                                        </Tooltip>
                                                                    </li>
                                                                </ul> : null
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                                {expanded === `section_${sectionIndex}` && subSection?.value_type === 1 ?
                                                    <div className='sub-section-body editor-wrapper '>
                                                        <CkEditorText
                                                            disabled={!onCheckFormPermission(currentFormDetail) || subSection?.is_system_generated === true}
                                                            htmlData={subSection?.is_system_generated === true ? helperFunc.convertTextToEditorHtml(subSection.value) : subSection.value}
                                                            onChangeData={(data) => onFieldChange( 'value',data, subSecIndex, section.id ) }
                                                            onBlurData={(data) => updateSectionInfo({ ...subSection, value: data}) }
                                                        />
                                                    </div>
                                                    : null}
                                            </Paper>
                                        )}
                                        {!section?.sub_sections?.length ? <div style={{ textAlign: 'center', padding: '30px 0' }}>No sub-sections added yet!</div> : null}
                                    </Paper>
                                </div>
                            </AccordionDetails>
                         
                        </Accordion>
                    )}
                </div> : <SectionImportTemplate params={params} getResponseBack={() => getContentSections()} sectionList={sectionCheckLists?.list} pageLoading={isLoading} initialLoader={initialLoader} />
                }
                {(castleAirInstance || testLessor) && !initialLoader ?
                    <Paper className='signatures-section'>
                        <div className='signatures-hd'> <span className='sig-lft-blk'>Signatures 
                            <Tooltip arrow title='Once a signature is added, it cannot be edited. To make changes, please delete the existing signature and add a new one.' placement='top'>
                             <Info style={{fontSize:'15px', marginLeft:'3px'}}/></Tooltip></span>
                            <Button disabled={!onCheckFormPermission(currentFormDetail)} color='primary' size='small' variant='contained' onClick={addSignatureRow}> Add Signature</Button>
                        </div>

                        <div className='signatures-content'>
                            {sectionCheckLists?.inspection_signatures?.length ? sectionCheckLists?.inspection_signatures?.map((signature, signatureIndex) =>
                                <Grid key={`signature_${signatureIndex}`} container spacing={2} className='signature-row' alignItems='center'>
                                    <Grid item sm={3}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <span style={{ marginRight: '10px' }}>{signatureIndex + 1}</span>
                                            <TextField
                                                required
                                                disabled={signature?.id}
                                                id={`section_name_${signature.name}`}
                                                fullWidth
                                                margin="none"
                                                label='Name'
                                                InputLabelProps={{ shrink: true }}
                                                value={signature.name || ''}
                                                onChange={(e) => { e.preventDefault(); e.stopPropagation(); onSignatureChange('name', e.target.value, signatureIndex) }}
                                                onFocus={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                                variant='outlined'
                                                error={error?.fields?.name && error?.errorIndex == signatureIndex ? true : false}
                                                helperText={error?.fields?.name && error?.errorIndex == signatureIndex ? error?.fields?.name : ''}
                                            />
                                        </div>
                                    </Grid>
                                    <Grid item sm='2'>
                                        {signature?.id && signature?.signature_date? 
                                         <TextField
                                            disabled={signature?.id}
                                            fullWidth
                                            required
                                            margin="none"
                                            label='Date'
                                            InputLabelProps={{ shrink: true }}
                                            value={signature?.signature_date || ''}
                                            variant='outlined'
                                        />
                                            :
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <KeyboardDatePicker
                                                required
                                                margin="none"
                                                id="signature_date"
                                                variant='outlined'
                                                format={fieldDateFormat}
                                                fullWidth
                                                disableFuture
                                                disabled={signature?.id}
                                                label='Date'
                                                value={signature?.signature_date || null}
                                                InputLabelProps={{ shrink: true }}
                                                inputVariant="outlined"
                                                error={error?.fields?.signature_date && error?.errorIndex == signatureIndex ? true : false}
                                                helperText={error?.fields?.signature_date && error?.errorIndex == signatureIndex ? error?.fields?.signature_date : ''}
                                                onChange={(data, value) => onSignatureChange('signature_date', data ? moment(data).format(backendDateFormat) : null, signatureIndex)}
                                            />
                                        </MuiPickersUtilsProvider>}
                                    </Grid>
                                    <Grid item sm={3}>
                                        <TextField
                                            disabled={signature?.id}
                                            id={`section_name_${signature.company}`}
                                            fullWidth
                                            required
                                            margin="none"
                                            label='Company'
                                            InputLabelProps={{ shrink: true }}
                                            value={signature.company || ''}
                                            onChange={(e) => { e.preventDefault(); e.stopPropagation(); onSignatureChange('company', e.target.value, signatureIndex) }}
                                            onFocus={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                            variant='outlined'
                                            error={error?.fields?.company && error?.errorIndex == signatureIndex ? true : false}
                                            helperText={error?.fields?.company && error?.errorIndex == signatureIndex ? error?.fields?.company : ''}
                                        />
                                    </Grid>
                                    <Grid item sm={3}>
                                        {signature?.file || signature?.image_url ?
                                            <img src={signature.file instanceof File ? URL.createObjectURL(signature.file) : signature?.image_url ?signature?.image_url :signature.file} style={{maxHeight:"50px", maxWidth:'150px'}} /> :
                                            <TextField
                                                disabled={signature?.id}
                                                id={`section_name_${signature.signature}`}
                                                fullWidth
                                                margin="none"
                                                label='Signature'
                                                InputLabelProps={{ shrink: true }}
                                                value={signature.signature || ''}
                                                onChange={(e) => { e.preventDefault(); e.stopPropagation(); onSignatureChange('signature', e.target.value, signatureIndex) }}
                                                onFocus={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                                variant='outlined'
                                                InputProps={{
                                                    endAdornment: onCheckFormPermission(currentFormDetail) ? (
                                                        <InputAdornment position="end">
                                                            <input
                                                                type="file"
                                                                accept="image/*"
                                                                id={`sig-upload-${signatureIndex}`}
                                                                style={{ display: 'none' }}
                                                                onChange={(e) => {
                                                                    const file = e.target.files[0];
                                                                    if (file) onSignatureChange('file', file, signatureIndex)
                                                                    e.target.value = '';
                                                                }}
                                                            />
                                                            { signature?.id?null:
                                                            <Tooltip title='Upload Signature' arrow placement='bottom'>
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => document.getElementById(`sig-upload-${signatureIndex}`).click()}
                                                                    >
                                                                    <PublishIcon fontSize="small" />
                                                                </IconButton>
                                                            </Tooltip>}
                                                        </InputAdornment>
                                                    ) : null
                                                }}
                                            />
                                        }
                                    </Grid>
                                    <Grid item sm='1' style={{display:'flex', flexFlow:'row-reverse'}}>
                                        {onCheckFormPermission(currentFormDetail) ?
                                            <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                                {signature?.id ? null :
                                                    <li className='list-inline-item' onClick={(e) => { e.preventDefault(); e.stopPropagation() }}>
                                                        <Tooltip title='Save' arrow placement='bottom'>
                                                            <Check color='primary' style={{ cursor: 'pointer' }} onClick={() => { onBlurSignature(signature, signatureIndex) }} />
                                                        </Tooltip>
                                                    </li>}
                                                <li className='list-inline-item'>
                                                    <Tooltip title='Delete Signature' arrow>
                                                        <DeleteOutlineIcon style={{ cursor: 'pointer' }} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDeleteSignature({ modal: true, data: { id: signature.id, index:signatureIndex } }) }} color='secondary' fontSize='medium' />
                                                    </Tooltip>
                                                </li>
                                            </ul> : null
                                        }
                                    </Grid>
                                </Grid>)
                                : <div style={{ textAlign: 'center' }}> No Signatures found</div>
                            }
                        </div>
                    </Paper> : null}
            </>
            }
            {addSection.modal ?
                <AddSection
                    getCurrentFormDetail={getCurrentFormDetail}
                    toggleModalFn={() => setAddSection({ modal: false, data: null })}
                    sectionObj={addSection}
                    getResponseBack={() => getContentSections('pageLoader')}
                /> : null
            }
            {deleteSection.modal ?
                <DeletePopUp
                    modal={deleteSection.modal}
                    toggleModalFn={() => setDeleteSection({ modal: false, type: '', data: null })}
                    title={`Delete ${deleteSection.type}`}
                    content={<h4>Are you sure you want to Delete?</h4>}
                    deleteRecordFn={() => onDeleteSection()}
                /> : null
            }
            { deleteSignature.modal ?
                <DeletePopUp
                    modal={deleteSignature.modal}
                    toggleModalFn={() => setDeleteSignature({modal:false, type:'', data:null})}
                    title={`Delete Signature`}
                    content={<h4>Are you sure you want to Delete?</h4>}
                    deleteRecordFn={() => deleteSignatureFn()}
                />:null
            }
            {isLoading ? <PageLoader />:null}
        </div>
    )
}
export default withRouter(SectionCheckList);